export default __webpack_public_path__ + "static/media/house-alt.aa62dd77.svg";